import React, { useState } from "react";
import { Button, Modal, message } from "antd";
import { graphql } from "react-apollo";
import { GROUPACCESS_QUERY } from "../../../../Apollo/Queries";
import { REMOVEGROUPACCESS_MUTATION } from "../../../../Apollo/Mutations";

const { confirm } = Modal;

const DeleteGroups = (props) => {
  const [loading, setLoading] = useState(false);
  function showConfirm() {
    const records = () => {
      return props.keys.length > 1 ? "these groups?" : "this group?";
    };
    confirm({
      title: `Are you sure you want to remove ${records()}`,
      content: "Click OK to continue.",
      onOk() {
        if (props.keys.length > 0) {
          const groupIds = props.keys;
          setLoading(true);
          props
            .mutate({
              variables: {
                groupIds,
              },
              //FIXME: Azure Migration DONE - Remove update store. It is preventing refetch after REMOVEGROUPACCESS_MUTATION
              /* update: (store, { data: { addGroupAccess } }) => {
                let Groups = store.readQuery({ query: GROUPACCESS_QUERY });
                for (let i = 0; i < groupIds.length; i++) {
                  Groups.getGroupsWithAccess.splice(
                    Groups.getGroupsWithAccess.findIndex(matchesEl),
                    1
                  );

                  function matchesEl(el) {
                    return el.id === groupIds[i];
                  }
                }
                store.writeQuery({ query: GROUPACCESS_QUERY, data: Groups });
              }, */
              refetchQueries: [
                {
                  //FIXME: Azure Migration DONE - Change refetch query from USERACCESS_QUERY to GROUPACCESS_QUERY
                  query: GROUPACCESS_QUERY
                }
              ]
            })
            .then(({ data }) => {
              setLoading(false);
              props.setToDelete([]);
            })
            .catch((error) => {
              setLoading(false);
              if (error.networkError) {
                if (error.networkError.result.errors[0].message !== null) {
                  message.error(error.networkError.result.errors[0].message);
                }
              } else {
                message.error("An Error occured. Please try again.");
              }
            });
        } else {
          message.error("No groups selected.");
        }
      },
    });
  }

  return (
    <div style={{ marginBottom: 15 }}>
      <Button loading={loading} type="danger" onClick={showConfirm}>
        {loading ? "Removing" : "Remove"}
      </Button>
    </div>
  );
};

const DeleteGroup = graphql(REMOVEGROUPACCESS_MUTATION)(DeleteGroups);

export default DeleteGroup;
